import { render, staticRenderFns } from "./RUG.vue?vue&type=template&id=1cf4b53a"
import script from "./RUG.vue?vue&type=script&lang=js"
export * from "./RUG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cf4b53a')) {
      api.createRecord('1cf4b53a', component.options)
    } else {
      api.reload('1cf4b53a', component.options)
    }
    module.hot.accept("./RUG.vue?vue&type=template&id=1cf4b53a", function () {
      api.rerender('1cf4b53a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/RUG.vue"
export default component.exports